import { useState, Fragment, useEffect } from "react";
import { CircularProgress, Backdrop, TextField, FormControl, Grid, FormLabel, RadioGroup, FormControlLabel, Radio, Box, Paper, Snackbar, BottomNavigation, BottomNavigationAction, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, useMediaQuery, useTheme } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddCardIcon from '@mui/icons-material/AddCard';

import "../css/Retiros.css"

import axios from "../api/axios"
import useAuth from '../hooks/useAuth';

export default function RetiroGanancias() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [mensaje, setMensaje] = useState("")
    const [disponible, setDisponible] = useState(0.00)
    const [transito, setTransito] = useState(0.00)
    const [retiroGanancia, setRetiroGanancia] = useState(1)
    const [monto, setMonto] = useState(0.00)
    const [comentario, setComentario] = useState("")
    const [openConfirmacion, setOpenConfirmacion] = useState(false)
    const [procesando, setProcesando] = useState(false)
    const [puedeReinvertir, setPuedeReinvertir] = useState(false)
    const [puedeRetirar, setPuedeRetirar] = useState(true)

    const { auth } = useAuth();
    const [montoError, setMontoError] = useState("");

    const actDisponible = async () => {
        console.log("=== RetiroGanancias actDisponible ===");
        console.log("auth:", auth);
        console.log("auth.inversionista:", auth.inversionista);
        try {
            console.log("Enviando request a retiros/disponible...");
            const respuesta = await axios.post("retiros/disponible", {
                inversionista: auth.inversionista,
                tipo: 2
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            console.log("Respuesta completa:", respuesta);
            console.log("Respuesta data:", respuesta.data);
            const data = respuesta.data;
            if (data.respuesta === "S") {
                console.log("Respuesta exitosa, seteando valores...");
                console.log("disponible:", data.disponible, "parseado:", parseFloat(data.disponible));
                console.log("transito:", data.transito, "parseado:", parseFloat(data.transito));
                console.log("puede_reinvertir:", data.puede_reinvertir);
                console.log("puede_retirar:", data.puede_retirar);
                setDisponible(parseFloat(data.disponible) || 0)
                setTransito(parseFloat(data.transito) || 0)

                const puedeReinvertirValue = parseInt(data.puede_reinvertir) !== 0;
                const puedeRetirarValue = data.puede_retirar !== undefined ? parseInt(data.puede_retirar) !== 0 : true;

                setPuedeReinvertir(puedeReinvertirValue)
                setPuedeRetirar(puedeRetirarValue)

                // Seleccionar automáticamente la primera opción disponible
                if (puedeRetirarValue) {
                    setRetiroGanancia(1)
                } else if (puedeReinvertirValue) {
                    setRetiroGanancia(2)
                }

                setMontoError("")
            } else {
                console.log("Respuesta NO exitosa:", data);
            }
        } catch (error) {
            console.log("Error en actDisponible:", error)
        }
    }

    // Cargar al montar el componente
    useEffect(() => {
        console.log("useEffect [] - montando componente");
        actDisponible();
    }, [])

    // Recargar cuando cambie el inversionista
    useEffect(() => {
        console.log("useEffect [auth.inversionista] - inversionista cambio a:", auth.inversionista);
        if (auth.inversionista) {
            actDisponible();
        }
    }, [auth.inversionista])

    const handleCloseMensaje = () => {
        setMensaje("")
    }
    const actionMsg = (
        <Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseMensaje}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </Fragment>
    );

    const confirmaGrabar = () => {
        return (
            <Dialog
                open={openConfirmacion}
                fullScreen={isMobile}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        m: isMobile ? 0 : 2,
                        maxHeight: isMobile ? '100%' : '90vh'
                    }
                }}
            >
                <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    color: 'white',
                    py: isMobile ? 1.5 : 2,
                    fontSize: isMobile ? '1rem' : '1.25rem'
                }}>
                    Confirmacion
                </DialogTitle>
                <DialogContent sx={{ p: isMobile ? 2 : 3, mt: 2 }}>
                    <Typography variant={isMobile ? 'body2' : 'body1'} sx={{ color: '#1e3a5f', textAlign: 'center' }}>
                        ¿Desea solicitar este retiro de ganancias?
                    </Typography>
                    <Box sx={{ mt: 2, p: 2, backgroundColor: 'rgba(30, 58, 95, 0.05)', borderRadius: 2 }}>
                        <Typography variant="body2" sx={{ color: '#4a5568', textAlign: 'center' }}>
                            Monto a retirar:
                        </Typography>
                        <Typography variant="h5" sx={{ color: '#d4af37', fontWeight: 'bold', textAlign: 'center' }}>
                            {parseFloat(monto).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{
                    p: isMobile ? 2 : 2,
                    gap: 1,
                    flexDirection: isMobile ? 'column' : 'row'
                }}>
                    <Button
                        onClick={handleCerrarConfirmar}
                        variant="outlined"
                        fullWidth={isMobile}
                        sx={{
                            order: isMobile ? 2 : 1,
                            color: '#1e3a5f',
                            borderColor: '#1e3a5f'
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => grabar()}
                        variant="contained"
                        fullWidth={isMobile}
                        sx={{
                            order: isMobile ? 1 : 2,
                            background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)'
                            }
                        }}
                    >
                        <span style={{ color: 'white' }}>Solicitar</span>
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const grabar = async () => {
        setOpenConfirmacion(false)
        setProcesando(true)
        try {
            const respuesta = await axios.post("retiros/grabar", {
                inversionista: auth.inversionista,
                tipo: 2,
                monto: String(monto),
                tiporetiroganancia: retiroGanancia,
                comentario: comentario
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            let data = respuesta.data;
            if (typeof data === 'string') {
                data = JSON.parse(data);
            }
            if (data.respuesta === "S") {
                limpiaPantalla();
                setMensaje("Retiro de ganancias solicitado exitosamente")
                actDisponible()
            } else {
                setMensaje(data.mensaje)
            }

        } catch (error) {
            console.log(error)
            setMensaje("Ha ocurrido un error de conexion, por favor intente mas tarde")
        }
        setProcesando(false)
    }

    const puedeGrabar = () => {
        let resultado = true;
        const montoNum = parseFloat(monto);
        const disponibleNum = parseFloat(disponible);

        if (isNaN(montoNum) || montoNum <= 0) {
            setMensaje("Debe digitar un monto valido mayor a cero")
            resultado = false;
        } else if (montoNum > disponibleNum) {
            const disponibleFormateado = disponibleNum.toLocaleString('en-US', { minimumFractionDigits: 2 });
            setMensaje(`El monto solicitado excede sus ganancias disponibles (${disponibleFormateado})`)
            resultado = false;
        }
        return resultado;
    }

    const handleClickGrabar = () => {
        if (puedeGrabar()) {
            setOpenConfirmacion(true)
        }
    }

    const limpiaPantalla = () => {
        setComentario("")
        setMonto("0.00")
        setRetiroGanancia(1)
        setMontoError("")
    }

    const handleCerrarConfirmar = () => {
        setOpenConfirmacion(false)
    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={() => { setProcesando(false) }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    return (
        <Box sx={{
            width: "100%",
            height: "100%",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: isMobile ? "flex-start" : "center",
            p: isMobile ? 1 : 2,
            overflow: 'auto'
        }}>
            <Snackbar
                open={mensaje.length === 0 ? false : true}
                autoHideDuration={6000}
                onClose={handleCloseMensaje}
                action={actionMsg}
                message={mensaje}
            />
            {objWait()}
            {confirmaGrabar()}
            <Paper sx={{
                width: isMobile ? '100%' : 600,
                maxWidth: '100%',
                p: isMobile ? 2 : 3,
                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                borderRadius: isMobile ? 2 : 3,
                boxShadow: '0 8px 32px rgba(30, 58, 95, 0.12)',
                border: '1px solid rgba(30, 58, 95, 0.1)'
            }}>
                <Box sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    borderRadius: isMobile ? '8px 8px 0 0' : '12px 12px 0 0',
                    borderBottom: '3px solid #d4af37',
                    mx: isMobile ? -2 : -3,
                    mt: isMobile ? -2 : -3,
                    mb: 2
                }}
                    padding={isMobile ? 1.5 : 2}
                >
                    <Typography
                        variant={isMobile ? 'h6' : 'h5'}
                        sx={{ color: "white", textAlign: "center", fontWeight: 700, letterSpacing: 1 }}
                    >
                        Retiro de Ganancias
                    </Typography>
                </Box>

                <BottomNavigation
                    sx={{
                        marginBottom: isMobile ? "20px" : "30px",
                        borderRadius: 2,
                        backgroundColor: 'rgba(30, 58, 95, 0.03)',
                        '& .MuiBottomNavigationAction-root': {
                            color: '#1e3a5f',
                            '&.Mui-selected': {
                                color: '#d4af37'
                            }
                        }
                    }}
                    showLabels
                    onChange={(_, newValue) => {
                        if (newValue === 0) { limpiaPantalla(); actDisponible(); }
                    }}
                >
                    <BottomNavigationAction label="Nuevo" icon={<SaveAltIcon />} />
                </BottomNavigation>

                {/* Resumen de ganancias en móvil */}
                {isMobile ? (
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: 1.5,
                        mb: 2
                    }}>
                        <Paper sx={{
                            p: 1.5,
                            textAlign: 'center',
                            background: 'rgba(30, 58, 95, 0.05)',
                            border: '1px solid rgba(30, 58, 95, 0.1)',
                            borderRadius: 2
                        }} elevation={0}>
                            <Typography variant="caption" sx={{ color: '#4a5568', display: 'block' }}>
                                Ganancias Acumuladas
                            </Typography>
                            <Typography variant="h6" sx={{ color: '#1e3a5f', fontWeight: 'bold' }}>
                                {parseFloat(disponible).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                            </Typography>
                        </Paper>
                        <Paper sx={{
                            p: 1.5,
                            textAlign: 'center',
                            background: 'rgba(212, 175, 55, 0.1)',
                            border: '1px solid rgba(212, 175, 55, 0.2)',
                            borderRadius: 2
                        }} elevation={0}>
                            <Typography variant="caption" sx={{ color: '#4a5568', display: 'block' }}>
                                En Tránsito
                            </Typography>
                            <Typography variant="h6" sx={{ color: '#d4af37', fontWeight: 'bold' }}>
                                {parseFloat(transito).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                            </Typography>
                        </Paper>
                    </Box>
                ) : (
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                                <TextField
                                    disabled
                                    size='small'
                                    id="ganancias-acumuladas"
                                    label="Ganancias acumuladas"
                                    value={parseFloat(disponible).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                    InputLabelProps={{
                                        readOnly: true
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                                <TextField
                                    disabled
                                    size='small'
                                    label='Fondos en Transito'
                                    value={parseFloat(transito).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                    InputLabelProps={{
                                        readOnly: true
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                )}

                <Grid container spacing={isMobile ? 2 : 2}>
                    <Grid item xs={12}>
                        <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                            <TextField
                                size={isMobile ? 'medium' : 'large'}
                                fullWidth={isMobile}
                                id="monto-retirar"
                                type="number"
                                label="Monto a Retirar:"
                                onChange={(event) => {
                                    const valor = event.target.value;
                                    setMonto(valor);
                                    const valorNum = parseFloat(valor);
                                    const disponibleNum = parseFloat(disponible);
                                    if (valorNum > disponibleNum) {
                                        setMontoError(`Excede las ganancias (${disponibleNum.toLocaleString('en-US', { minimumFractionDigits: 2 })})`);
                                    } else {
                                        setMontoError("");
                                    }
                                }}
                                value={monto}
                                error={montoError.length > 0}
                                helperText={montoError}
                                InputProps={{
                                    sx: {
                                        fontSize: isMobile ? '1.25rem' : '1rem',
                                        fontWeight: 'bold',
                                        color: '#1e3a5f'
                                    }
                                }}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl component="fieldset" fullWidth>
                            <FormLabel
                                component="legend"
                                sx={{
                                    color: '#1e3a5f',
                                    fontWeight: 600,
                                    mb: 1,
                                    fontSize: isMobile ? '0.875rem' : '1rem',
                                    textAlign: isMobile ? 'center' : 'left'
                                }}
                            >
                                ¿Qué desea hacer con sus ganancias?
                            </FormLabel>
                            <RadioGroup
                                row={!isMobile}
                                value={retiroGanancia}
                                onChange={(event) => { setRetiroGanancia(parseInt(event.target.value)) }}
                                sx={{
                                    justifyContent: 'center',
                                    gap: isMobile ? 1 : 2,
                                    flexDirection: isMobile ? 'column' : 'row'
                                }}
                            >
                                {puedeRetirar && (
                                    <FormControlLabel
                                        value={1}
                                        control={<Radio sx={{ color: '#1e3a5f', '&.Mui-checked': { color: '#d4af37' } }} />}
                                        label="Retirar"
                                        sx={{
                                            border: '1px solid #1e3a5f',
                                            borderRadius: 2,
                                            px: 2,
                                            py: isMobile ? 0.5 : 1,
                                            m: 0,
                                            backgroundColor: retiroGanancia === 1 ? 'rgba(30, 58, 95, 0.1)' : 'transparent',
                                            width: isMobile ? '100%' : 'auto'
                                        }}
                                    />
                                )}
                                {puedeReinvertir && (
                                    <FormControlLabel
                                        value={2}
                                        control={<Radio sx={{ color: '#1e3a5f', '&.Mui-checked': { color: '#d4af37' } }} />}
                                        label="Enviar al disponible"
                                        sx={{
                                            border: '1px solid #1e3a5f',
                                            borderRadius: 2,
                                            px: 2,
                                            py: isMobile ? 0.5 : 1,
                                            m: 0,
                                            backgroundColor: retiroGanancia === 2 ? 'rgba(30, 58, 95, 0.1)' : 'transparent',
                                            width: isMobile ? '100%' : 'auto'
                                        }}
                                    />
                                )}
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="nota"
                            fullWidth
                            size={isMobile ? 'small' : 'medium'}
                            value={comentario}
                            onChange={(event) => { setComentario(event.target.value) }}
                            label="Comentario"
                            multiline
                            rows={isMobile ? 2 : 3}
                            maxRows={4}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            fullWidth
                            size="large"
                            onClick={handleClickGrabar}
                            sx={{
                                mt: 1,
                                py: 1.5,
                                fontSize: '1.1rem',
                                fontWeight: 'bold',
                                background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)'
                                }
                            }}
                        >
                            SOLICITAR RETIRO
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </Box>
    )
}
